import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { PictureCover } from "../PictureCover"
import { PocketBand } from "../PocketBand"
import { PocketMonths } from "../PocketMonths"

/** Vinnie, a long pocket calendar on one side: a band of picture with the
 * year on it at its head, under it January to June three across on the left,
 * July to December on the right. */
export const Vinnie: CalendarDesign = {
  cover: PictureCover({}),
  page: boxes => {
    const { areas, below } = PocketBand(boxes, 0.2)
    const [left, right] = Slice.grid(below, 2, 1, boxes.gap)
    return [
      ...areas,
      ...PocketMonths(left!, boxes.year, 3, 1, 6),
      ...PocketMonths(right!, boxes.year, 3, 7, 12),
    ]
  },
  pages: "year",
}
